export const createLinkedFollowerPaintAuthority = ({ requestFrame, cancelFrame }) => {
  if (typeof requestFrame !== 'function' || typeof cancelFrame !== 'function') {
    throw new TypeError('linked_follower_paint_scheduler_invalid');
  }

  let current = null;

  const cancel = () => {
    const state = current;
    if (!state) return false;
    current = null;
    state.cancelled = true;
    if (state.firstFrame !== null) cancelFrame(state.firstFrame);
    if (state.secondFrame !== null) cancelFrame(state.secondFrame);
    state.firstFrame = null;
    state.secondFrame = null;
    return true;
  };

  const schedule = ({ root, slice, generation, isCurrent, isAcceptedVisible, publish } = {}) => {
    if (!root || !Number.isSafeInteger(slice) || slice < 0
        || !Number.isSafeInteger(generation) || generation <= 0
        || typeof isCurrent !== 'function' || typeof isAcceptedVisible !== 'function'
        || typeof publish !== 'function') return false;

    cancel();
    const state = {
      cancelled: false,
      firstFrame: null,
      secondFrame: null,
    };
    current = state;

    try {
      state.firstFrame = requestFrame(() => {
        state.firstFrame = null;
        if (state.cancelled || current !== state) return;
        try {
          state.secondFrame = requestFrame(() => {
            state.secondFrame = null;
            if (state.cancelled || current !== state) return;
            current = null;
            let ownsRequest = false;
            let ownsVisibleSurface = false;
            try { ownsRequest = isCurrent() === true; } catch (_) { ownsRequest = false; }
            try { ownsVisibleSurface = isAcceptedVisible() === true; } catch (_) { ownsVisibleSurface = false; }
            if (!ownsRequest || !ownsVisibleSurface) return;
            try { publish({ root, slice, generation }); } catch (_) {}
          });
        } catch (_) {
          if (current === state) current = null;
          state.cancelled = true;
        }
      });
    } catch (_) {
      current = null;
      state.cancelled = true;
      return false;
    }
    return true;
  };

  return Object.freeze({ schedule, cancel });
};
